import { PreferencesGAUserPropertiesContext } from "~applications";
import { createStaticContextProvider, lazyValue } from "~utils";

export const PreferencesGAUserPropertiesProvider = createStaticContextProvider(
  PreferencesGAUserPropertiesContext,
  lazyValue(() =>
    import("./preferences-ga-user-properties").then(
      (module) => module.preferencesGAUserProperties,
    ),
  ),
);
